import * as tslib_1 from "tslib";
import { OnInit, ChangeDetectorRef, OnDestroy, ElementRef, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { Subject, combineLatest, merge } from 'rxjs';
import { map, takeUntil, filter } from 'rxjs/operators';
import { Selectors, Actions as RootActions } from 'store/root-reducer';
import { CustomerActionTypes } from 'store/actions/customer.actions';
import { RecordActionTypes } from 'store/actions/record.action';
import { SearchActionTypes } from 'store/actions/search.actions';
import * as CustomerActions from 'store/actions/customer.actions';
import { SnackbarService } from 'app/services/snackbar.service';
import { environment } from 'environments/environment';
import { CustomersBase } from '../../customers-base';
var CustomerOverviewPage = /** @class */ (function (_super) {
    tslib_1.__extends(CustomerOverviewPage, _super);
    function CustomerOverviewPage(activatedRoute, router, cdRef, store, actions$, dialog, snackbar) {
        var _this = _super.call(this) || this;
        _this.activatedRoute = activatedRoute;
        _this.router = router;
        _this.cdRef = cdRef;
        _this.store = store;
        _this.actions$ = actions$;
        _this.dialog = dialog;
        _this.snackbar = snackbar;
        _this.unsubscribe$ = new Subject();
        _this.breadcrumbs = _this.store.select(Selectors.customer.getCustomer)
            .pipe(takeUntil(_this.unsubscribe$), map(function (customer) {
            if (customer) {
                return [
                    {
                        url: '/customers',
                        label: 'Customer List'
                    }, {
                        url: "/customers/" + customer.id,
                        label: customer.name
                    }
                ];
            }
            else {
                return [];
            }
        }));
        _this.enableAresIntegration = environment['ENABLE_ARES_INTEGRATION'];
        return _this;
    }
    CustomerOverviewPage.prototype.ngOnInit = function () {
        this.getLoadingStatus();
        this.getRequireUpdateActionStatus();
        this.customerID = this.activatedRoute.snapshot.params['id'];
        this.initCustomer();
    };
    /**
     * Get loading status from store
     * @method getLoadingStatus
     */
    CustomerOverviewPage.prototype.getLoadingStatus = function () {
        this.loading$ = combineLatest([
            this.store.select(Selectors.customer.getLoading),
            this.store.select(Selectors.record.getLoading),
            this.store.select(Selectors.search.getLoading)
        ]).pipe(takeUntil(this.unsubscribe$), map(function (_a) {
            var customerLoading = _a[0], recordLoading = _a[1], screeningLoading = _a[2];
            return customerLoading.includes(CustomerActionTypes.GET_CUSTOMER) ||
                customerLoading.includes(CustomerActionTypes.PATCH_CUSTOMER) ||
                recordLoading.includes(RecordActionTypes.GET_OTHER_DATA) ||
                recordLoading.includes(RecordActionTypes.GET_INDIVIDUAL_RECORD) ||
                recordLoading.includes(RecordActionTypes.GET_CORPORATE_RECORD) ||
                screeningLoading.includes(SearchActionTypes.POST_SCREENING);
        }));
    };
    /**
     * Dispatch the effect to check search engine credit and proceed accordingly
     * @method checkBalance
     */
    CustomerOverviewPage.prototype.checkBalance = function () {
        this.store.dispatch(new RootActions.billable.CheckBalance({
            actions: [
                new RootActions.search.PostScreening({
                    generateReport: true,
                    invalidOnly: true,
                    redirectToScreening: true
                })
            ]
        }));
    };
    /**
     * Init customer for document wrapper component
     * @method initCustomer
     */
    CustomerOverviewPage.prototype.initCustomer = function () {
        var _this = this;
        combineLatest([
            merge(this.store.select(Selectors.record.getCorporateRecord), this.store.select(Selectors.record.getIndividualRecord)),
            this.store.select(Selectors.customer.getCustomer)
        ]).pipe(takeUntil(this.unsubscribe$)).subscribe(function (_a) {
            var record = _a[0], customer = _a[1];
            if (record && customer) {
                _this.customer = { record: record, customer: customer };
            }
            _this.cdRef.detectChanges();
        });
        this.store.select(Selectors.customer.getCrps)
            .pipe(filter(function (crps) { return crps.results.length > 0; }), takeUntil(this.unsubscribe$)).subscribe(function (crps) {
            var primaryCrp = crps.results.find(function (crp) { return crp.primary === true; });
            if (primaryCrp && primaryCrp.recordType === 'INDIVIDUAL') {
                _this.store.dispatch(new RootActions.record.GetIndividualRecord({
                    recordId: primaryCrp.record,
                    getOtherData: true
                }));
            }
            else if (primaryCrp && primaryCrp.recordType === 'CORPORATE') {
                _this.store.dispatch(new RootActions.record.GetCorporateRecord({
                    recordId: primaryCrp.record,
                    getOtherData: true
                }));
            }
        });
        this.store.select(Selectors.record.getRecordOtherData)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (res) {
            if (_this.hasValidOtherData(res)) {
                _this.otherData = res;
            }
            else {
                _this.otherData = null;
            }
        });
    };
    /**
    * Adds form in modal window for adding message to require update
    * @method openRequireUpdateForm
    */
    CustomerOverviewPage.prototype.openRequireUpdateForm = function () {
        this.requireUpdateFormRef = this.dialog.open(this.requireUpdateForm, {
            width: '650px'
        });
    };
    /**
    * Closes modal for adding adding message to require update and clearing the text inside
    * @method closeRequireUpdateModal
    */
    CustomerOverviewPage.prototype.closeRequireUpdateModal = function () {
        this.requireUpdateContent = '';
        this.requireUpdateFormRef.close();
    };
    CustomerOverviewPage.prototype.requireUpdate = function () {
        var payload = {
            customer: Object.assign({}, this.customer.customer),
            redirectToCustomerList: false,
            quietUpdate: true
        };
        payload.customer.integrationStatus = 'REQUIRE UPDATE';
        payload.customer.callback_message = this.requireUpdateContent;
        this.store.dispatch(new RootActions.customer.PatchCustomer(payload));
        this.closeRequireUpdateModal();
        this.cdRef.detectChanges();
    };
    /**
     * Inits observables for getting update domain action status
     * @method getRequireUpdateActionStatus
     */
    CustomerOverviewPage.prototype.getRequireUpdateActionStatus = function () {
        var _this = this;
        this.actions$.pipe(ofType(CustomerActions.CustomerActionTypes.PATCH_CUSTOMER_SUCCESS), takeUntil(this.unsubscribe$))
            .subscribe(function () {
            _this.snackbar.success('Update request successfully sent');
        });
        this.actions$.pipe(ofType(CustomerActions.CustomerActionTypes.PATCH_CUSTOMER_FAILURE), takeUntil(this.unsubscribe$))
            .subscribe(function (res) {
            _this.snackbar.error(res.payload);
            _this.store.dispatch(new RootActions.customer.ClearErrors());
        });
    };
    CustomerOverviewPage.prototype.toEditPage = function (crpId, recordId) {
        this.router.navigateByUrl("customers/" + this.customerID + "/edit");
    };
    CustomerOverviewPage.prototype.addCRP = function () {
        this.router.navigate(["/customers/" + this.customer.customer.id + "/edit/crp-add"], { fragment: 'addCrpCard' });
    };
    CustomerOverviewPage.prototype.ngOnDestroy = function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    return CustomerOverviewPage;
}(CustomersBase));
export { CustomerOverviewPage };
